import { render } from "./VideoHeader.vue?vue&type=template&id=d6e15b0c&scoped=true"
import script from "./VideoHeader.vue?vue&type=script&lang=js"
export * from "./VideoHeader.vue?vue&type=script&lang=js"

import "./VideoHeader.vue?vue&type=style&index=0&id=d6e15b0c&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e15b0c"]])

export default __exports__